import React, { useRef } from 'react';
import SelectOption from 'styles/blocks/selectOption';
import { useAutoFocus } from 'common/customHooks';
import { ColumnDiv } from 'styles/elements/div';
import { STRINGS } from 'config';

const { PRODUCT: { PRIMARY_CARE, E_SPECIALIST } } = STRINGS;

export function Select({ answerId, index, text, isMounted, triageLevel, selected, onSelectOption, onDeselectOption, isClinicalReviewMode, product }) {
  const isFirst = index === 0;

  const buttonRef = useRef();
  useAutoFocus(isFirst, isMounted, buttonRef);

  function createMarkup(answerText) {
    return { __html: answerText };
  }

  function toggleAnswer() {
    if (selected) {
      onDeselectOption(answerId);
    } else {
      onSelectOption(answerId);
    }
  }

  return (
    <ColumnDiv>
      <SelectOption.HiddenCheckbox checked={selected} onChange={() => toggleAnswer()} id={`checkbox-${index}`} />
      <SelectOption
        selected={selected}
        ref={buttonRef}
        isClinicalReviewMode={isClinicalReviewMode}
        triageLevel={triageLevel}
        isMultiSelect
        as="label"
        htmlFor={`checkbox-${index}`}
      >
        <SelectOption.DisplayCheckbox aria-hidden checked={selected} />
        <SelectOption.Container isClinicalReviewMode={isClinicalReviewMode}>
          <SelectOption.Text dangerouslySetInnerHTML={createMarkup(text)} />
          <SelectOption.ClinicalReviewIcon triageLevel={isClinicalReviewMode && (product === PRIMARY_CARE || product === E_SPECIALIST) && triageLevel} />
        </SelectOption.Container>
        <SelectOption.ClinicalReviewHelpText isClinicalReviewMode={isClinicalReviewMode}>{answerId}</SelectOption.ClinicalReviewHelpText>
      </SelectOption>
    </ColumnDiv>
  );
}
